import {
  Box3,
  MathUtils,
  PerspectiveCamera,
  Sphere,
  Vector3,
  type Object3D,
} from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';

export class CameraController {
  readonly controls: OrbitControls;

  constructor(
    private readonly camera: PerspectiveCamera,
    canvas: HTMLCanvasElement,
  ) {
    this.controls = new OrbitControls(camera, canvas);
    this.controls.enableDamping = true;
    this.controls.dampingFactor = 0.08;
    this.controls.screenSpacePanning = true;
    this.controls.maxPolarAngle = Math.PI * 0.98;
    this.controls.target.set(0, 0, 0);
    this.controls.update();
  }

  fit(object: Object3D): void {
    const box = new Box3().setFromObject(object);
    if (box.isEmpty()) return;

    const sphere = box.getBoundingSphere(new Sphere());
    const halfFov = MathUtils.degToRad(this.camera.fov / 2);
    const distance = Math.max(sphere.radius / Math.tan(halfFov), 10) * 1.25;
    const direction = new Vector3(1, 0.8, 1).normalize();

    this.controls.target.copy(sphere.center);
    this.camera.position.copy(sphere.center).addScaledVector(direction, distance);
    this.camera.near = Math.max(distance / 10_000, 0.01);
    this.camera.far = Math.max(distance * 100, 10_000);
    this.camera.updateProjectionMatrix();
    this.controls.update();
  }

  update(): void {
    this.controls.update();
  }

  dispose(): void {
    this.controls.dispose();
  }
}

